import { VideoMetricColumns } from '../elevated-columns/performance';

export const restrictionSets = {
  AllConversions: {
    isAllowed: () => true,
    columns: [
      'AllConversions',
      'AllConversionRate',
      'AllCostPerConversion',
      'AllReturnOnAdSpend',
      'AllRevenuePerConversion',
      'AllRevenue',
      'EstimatedAllConversions',
      'EstimatedAllConversionRate',
    ],
  },
  AIM: {
    isAllowed: permissions => permissions.IsAIMCampaignEnabled,
    columns: [
      'Headline',
      'LongHeadline',
      'BusinessName',
      'AudienceImpressionSharePercent',
      'AudienceImpressionLostToRankPercent',
      'AudienceImpressionLostToBudgetPercent',
      'RelativeCTR',
    ],
  },
  GoalCategory: {
    isAllowed: () => true,
    columns: ['GoalCategory'],
  },
  GoalType: {
    isAllowed: permissions =>
      permissions.IsInStoreTransactionAttributionSupported,
    columns: ['GoalType'],
  },
  AdGroupType: {
    isAllowed: permissions =>
      permissions.IsDSAMixedModeCampaignEnabled,
    columns: ['AdGroupType', 'AdGroupTypePreview'],
  },
  ViewConversions: {
    isAllowed: permissions => permissions.IsViewThroughConversionEnabled,
    columns: [
      'ViewThroughConversions',
      'FullViewConversions',
    ],
  },
  ViewThroughConversionsRevenue: {
    isAllowed: permissions => permissions.IsViewThroughConversionsRevenueEnabled,
    columns: [
      'ViewThroughConversionRate',
      'ViewThroughRevenue',
      'ViewThroughCostPerConversion',
      'ViewThroughReturnOnAdSpend',
    ],
  },
  ConversionValueRuleMetrics: {
    isAllowed: permissions => permissions.dynamic.ConvValueRules,
    columns: [
      'RevenueAdjustment',
      'AllRevenueAdjustment',
    ],
  },
  ConversionValueRuleViewThroughMetrics: {
    isAllowed: permissions => permissions.dynamic.ConvValueRules,
    columns: [
      'ViewThroughRevenueAdjustment',
    ],
  },
  AvgPositionDeprecationPhase1: {
    isAllowed: permissions => permissions.IsAvgPositionDeprecationPhase1Enabled,
    columns: [
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
  },
  AvgPositionDeprecationPhase2: {
    isAllowed: permissions => !permissions.IsAvgPositionDeprecationPhase2Enabled,
    columns: [
      'AveragePosition',
    ],
  },
  VideoMetrics: {
    isAllowed: permssions => permssions.IsVideoAdsPerfMetricsEnabled,
    columns: VideoMetricColumns,
  },
  VideoMetricsV2: {
    isAllowed: permissions => permissions.dynamic.IsVideoAdsPerfMetricsV2Enabled,
    columns: ['VideoStarts', 'VideoSkips', 'CPCV'],
  },
  AdScenarioType:
  {
    isAllowed: permssions => permssions.IsVerticalAdsReportingPhase1Enabled,
    columns: [
      'AdScenarioType',
    ],
  },
  NeighborhoodLocationType: {
    isAllowed: () => true,
    columns: [
      'Neighborhood',
      'QueryIntentNeighborhood',
    ],
  },
  Conversions: {
    isAllowed: permissions => !permissions.dynamic.PartialConversions,
    columns: [
      'AllConversions',
      'Conversions',
      'ConversionRate',
      'AllConversionRate',
      'LowQualityConversions',
      'CostPerConversion',
      'ViewThroughCostPerConversion',
      'ViewThroughConversionRate',
      'AllCostPerConversion',
    ],
  },
  ConversionsQualified: {
    isAllowed: permissions => permissions.dynamic.PartialConversions,
    columns: [
      'AllConversionsQualified',
      'ConversionsQualified',
      'ConversionRateQualified',
      'AllConversionRateQualified',
      'LowQualityConversionsQualified',
      'CostPerConversionQualified',
      'ViewThroughCostPerConversionQualified',
      'ViewThroughConversionRateQualified',
      'AllCostPerConversionQualified',
    ],
  },
  Description: {
    isAllowed: permssions => permssions.IsDSADynamicDescriptionPhase1Enabled,
    columns: [
      'Description',
    ],
  },
  AdId: {
    isAllowed: () => true,
    columns: [
      'AdId',
    ],
  },
  UCMReportBudgetColumns: {
    isAllowed: () => false,
    columns: [
      'IncrementalBudgetAmount',
      'DailyBudgetAmount',
      'BudgetId',
    ],
  },
  CPSReporting: {
    isAllowed: permissions => !permissions.dynamic.CPSReporting,
    columns: [
      'RevenuePerSale',
    ],
  },
  PerformanceMax: {
    isAllowed: permissions => permissions.dynamic.PerformanceMaxCampaigns && permissions.dynamic.PerformanceMaxCampaignsPhaseTwoReporting,
    columns: [
      'AssetGroupId',
      'AssetGroupName',
      'AssetGroupStatus',
      'CampaignType',
    ],
  },
  ReachAndFreq: {
    isAllowed: permissions => permissions.dynamic.ReachAndFrequency,
    columns: [
      'AverageImpressionFrequencyPerUser',
      'AverageImpressionFrequencyPerUser7Day',
      'Reach',
    ],
  },
  ReachAndFreq7Day: {
    isAllowed: permissions => permissions.dynamic.ReachAndFrequency7Day,
    columns: [
      'AverageImpressionFrequencyPerUser7Day',
    ],
  },
  AdStrength: {
    isAllowed: () => true,
    columns: [
      'AdStrength',
      'AdStrengthActionItems',
    ],
  },
  BoostPlacement: {
    isAllowed: permissions => permissions.IsAmplifyEnabled && permissions.dynamic.BoostPlacementReporting,
    columns: [
      'PlacementName',
    ],
  },
  NewCustomerAcquisitionGoal: {
    isAllowed: permissions => permissions.dynamic.NewCustomerAcquisition,
    columns: [
      'NewCustomerConversions',
      'NewCustomerRevenue',
      'NewCustomerConversionRate',
      'NewCustomerReturnOnAdSpend',
      'NewCustomerCPA',
    ],
  },
  InsertionOrderAccountLevel: {
    // Only show these columns for 2 scenarios: 1. for customer level. 2. for column chooser
    isAllowed: (permissions, isCustomerScope, isColumnChooserRenderer) => permissions.dynamic.InsertionOrderReport && (isCustomerScope || isColumnChooserRenderer),
    columns: [
      'BillToCustomerName',
      'BillToCustomerNumber',
    ],
  },
  InsertionOrderFilter: {
    isAllowed: () => false, // Disable columns in filter by default
    columns: [
      'AccountId',
      'InsertionOrderId',
      'BDAmount',
      'MismatchedAmount',
      'MismatchedReason',
      'AdjustmentCouponAmount',
      'SpendCouponAmount',
      'BudgetChangedAmount',
      'SpendAmount',
      'AdjustmentAmount',
      'BudgetChangeOldValue',
      'BudgetChangeNewValue',
    ],
  },
  InsertionOrderDisplay: {
    isAllowed: () => false, // Hide columns in grid by default
    columns: [
      'AccountId',
      'InsertionOrderId',
      'BDAmount',
      'MismatchedAmount',
      'MismatchedReason',
      'AdjustmentCouponAmount',
      'SpendCouponAmount',
      'BudgetChangedAmount',
      'SpendAmount',
      'AdjustmentAmount',
      'BudgetChangeOldValue',
      'BudgetChangeNewValue',
    ],
  },
};
